<template>
  <div style="width: 100%; height: 100%;">
    <Header1></Header1>
    <div class="body">
      <div class="beiTitle">当前位置：首页 > 捐赠榜</div>
      <div v-for="(item, index) in beis"
           :style="backgroundDiv"
           class="bgClass">
        <p class="ptitle">尊敬的<span>{{item.title}}</span>：</p>
        <p class="pcont">{{item.subtitle}}。</p>
        <p class="foot1">{{item.description}}</p>
        <p class="foot2">{{item.pubulishdate}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Header1 from '../components/Header1.vue';
import { request } from '../API/ApiUrl';

export default {
  components: {
    Header1
  },
  data () {
    return {
      currentDate: new Date(),
      backgroundDiv: {
        backgroundImage: 'url(' + require('./../assets/Img/jzb.png') + ') '
      },
      beis: []
    };
  },
  mounted () {
    this.addVisit();
    this.getBeiList();
  },
  methods: {
    addVisit () {
      request('/apiVisit/addVisitData', { module: 101 }).then(res => {

      })
    },
    getBeiList () {
      request('/apigdb/getgdblist', { module: 1, offset: 1, limit: 100 }).then(res => {
        //console.log(res)
        if (res.code == 200) {
          this.beis = res.data
          // this.beis.pubulishdate = res.data.pubulishdate.substring(0, 10)
          for (var i = 0; i < this.beis.length; i++) {
            this.beis[i].pubulishdate = this.beis[i].pubulishdate.substring(0, 10)
          }
        }
      })
    },
  },
};
</script>

<style scoped>
.bgClass .P3 {
  margin-bottom: 30px;
}
.bgClass .foot1,
.bgClass .foot2 {
  text-align: right;
  font-size: 18px;
  min-height: 24px;
  max-height: 24px;
}
.bgClass p {
  margin: 0;
  padding: 0;
  font-size: 20px;
}
.bgClass .ptitle {
  margin-top: 15px;
  margin-bottom: 15px;
  font-size: 20px;
}
.bgClass .ptitle span {
  text-decoration: underline;
  font-size: 20px;
}
.bgClass .pcont {
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  text-indent: 2em;
  /* margin-top: 15px;
  margin-bottom: 15px; */
  min-height: 2rem;
  max-height: 2rem;
}
.body {
  width: 1000px;
  margin: auto;
}
.beiTitle {
  padding: 30px 0;
  width: 250px;
  text-align: center;
  font-size: 16px;
}
.bgClass {
  width: 418px;
  padding-top: 148px;
  box-sizing: border-box;
  padding-left: 40px;
  padding-right: 40px;
  /* background-size: contain; */
  background-size: 100%;
  min-height: 438px;
  max-height: 438px;

  /* box-shadow: 2px 3px 7px #4bb1aa; */
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 5px 20px 5px 20px;
  margin-left: 82px;
  /* text-align: center; */
  border: 1px solid rgb(236, 244, 251);
  display: inline-block;
}
.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
</style>
